export default "__VITE_PUBLIC_ASSET__8c2812a2__"